import { Types } from '../../../../../actions/dashboards'
import { Metrics } from '../../../../../constants/Dashboards'
import buildAsyncStatReducer from '../../asyncStatReducer'
import { DevicesOnline } from '../../types'

/**
 * WFH Devices Online reducer
 */
const wfhDevicesOnline = buildAsyncStatReducer({
    key: Metrics.WFH_DEVICES_ONLINE,
    types: {
        request: Types.DASHBOARD_WFH_DEVICES_ONLINE.request,
        success: Types.DASHBOARD_WFH_DEVICES_ONLINE.success,
        failure: Types.DASHBOARD_WFH_DEVICES_ONLINE.failure,
    },
    transform: (state, { payload }): DevicesOnline => {
        const { online, offline }: DevicesOnline = payload || {}
        return { online, offline }
    },
})

export default wfhDevicesOnline
